import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import {
  getActiveSection,
  getIsSubfoldersPage,
  getPublishedFolderId,
  getPublishedTierId,
  getPublishedTiers,
  getStudioParams,
  getSelectedFolder,
} from '../../../../selectors/studio';
import { Props } from './PublishedLayout';

export type StateProps = Pick<
  Props,
  | 'activeSection'
  | 'isSubfoldersPage'
  | 'publishedFolderId'
  | 'publishedTierId'
  | 'folder'
  | 'tiers'
  | 'contentType'
>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  activeSection: getActiveSection(state),
  isSubfoldersPage: getIsSubfoldersPage(state),
  publishedFolderId: getPublishedFolderId(state),
  publishedTierId: getPublishedTierId(state),
  tiers: getPublishedTiers(state),
  folder: getSelectedFolder(state),
  contentType: getStudioParams(state).contentType,
});

export default connect(mapStateToProps);
